import type { EquipmentType } from '@rock/types';

/**
 * Equipment types the library can hold material for.
 *
 * `system`-scoped types are excluded everywhere — picker and pills, gaps included. A "Furnace
 * System" is a grouping of the real units underneath it (furnace unit, thermostat, air handler);
 * there is no cabinet to photograph and no nameplate to scan, so it would sit at a permanent (0)
 * and add noise to every type row.
 *
 * `component` and `supplies` stay: a thermostat or an air filter is a real object with a label on it.
 */
export function isPhotographableType(type: EquipmentType): boolean {
    return type.scope !== 'system';
}
